import { Loader2 } from "lucide-react";

export default function DefaultPendingComponent() {
	return (
		<div className="absolute top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center">
			<Loader2 className="size-6 text-t3 flex-shrink-0 animate-spin" />
		</div>
	);
}
